import { WindowHelper } from '../WindowHelper';
import WorkListRestoreLinks from './work-list-restore-links';

export default class WorkListActiveTouch extends WorkListRestoreLinks {
    closeModal(node) {
        node.querySelector('.work-list-close').addEventListener(super.getEvent(), ((event) => {
            // console.log('default was prevented', event.defaultPrevented);
            // console.log('close called');
            window.setTimeout(() => {
                node.querySelector('.highlighted-work-list-item').classList.remove('is-active');
                // console.log('deferred closing');
            }, 300);
        }).bind(this, node), true);
    }

    initTouch() {
        for (let i = 0; i < super.getTriggerNodes().length; i++) {
            super.getTriggerNodes()[i].classList.add('is-touch');
            super.resetLinks(super.getTriggerNodes()[i]);
            this.closeModal(super.getTriggerNodes()[i]);
        }
    }

    constructor() {
        super();
        if (WindowHelper.isTouchDevice() && WindowHelper.isElementThere('.work-list-container')) this.initTouch();
    }
}
